// Gradient fill helpers (gradient stops, angle, Solid/Gradient mode) shared by TextPanel, ShapePanel, LogoPanel
// and LeftSection (the FDIC + Equal Housing fill slot of the mixed selection, until Stage 5).
// Moved verbatim from LeftSection.vue. Do NOT rename.
// The host must provide: contentList, activeObjectForLeftPanel, getSelectedObjectsList, selectedObjectsList,
// isMultiPropertySelection (panelContext) and emitUndoRedoRequest (objectEffects).
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import {
  findObjectById,
  findFirstSelectedObject,
  isSvgStrokeObject,
} from '@/components/Canvas/utils/groupHelpers';

export default {
  computed: {
    selectedGradientColor() {
      const gradient = this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.gradient;
      const colors   = gradient && gradient.colors;
      if (!colors || !colors.length) {
        return null;
      }
      return colors.find(color => color.isSelected) || colors[0];
    },
    getSelectedPointOfGradient() {
      return this.selectedGradientColor ? this.selectedGradientColor.id : null;
    },
    getColorLabelShape() {
      if (!this.activeObjectForLeftPanel) { return '#000'; }
      if (this.activeObjectForLeftPanel.type == 'image'
          && (this.activeObjectForLeftPanel.ImageType == 'SVGImage' || this.activeObjectForLeftPanel.ImageType.indexOf('FDICText') !== -1 || this.activeObjectForLeftPanel.ImageType.indexOf('FDICLogo') !== -1)
          && !this.activeObjectForLeftPanel.isGradient) {
        return this.activeObjectForLeftPanel.SvgProperty.DefaultColor;
      }
      if (this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.isGradient) {
        return this.selectedGradientColor ? this.selectedGradientColor.rgba : '#000';
      }
      return this.activeObjectForLeftPanel ? this.activeObjectForLeftPanel.DefaultColor : '#000';
    },
  },
  methods: {
    updateSelectedGradientAngle(angle) {
      const list = this.getSelectedObjectsList;
      if (this.isMultiPropertySelection) {
        list.forEach((object) => {
          this.updateSelectedGradientAngleById(angle, object.Id);
        });
      } else {
        const selectedObject = findFirstSelectedObject(this.contentList);
        if (!selectedObject) { return; }
        this.updateSelectedGradientAngleById(angle, selectedObject.Id);
      }
    },
    applySvgGradientFill(selectedObject) {
      if (!selectedObject || !selectedObject.isGradient || !isSvgStrokeObject(selectedObject)) { return; }
      EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, null, selectedObject.Id);
    },
    updateSelectedGradientAngleById(angle, objectId) {
      const selectedObject = findObjectById(this.contentList, objectId);
      if (!selectedObject || !selectedObject.gradient) { return; }
      selectedObject.gradient.angle = angle;
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      if (selectedObject.isGradient && (isSvgStrokeObject(selectedObject) || selectedObject.type === 'text' || selectedObject.ImageType === 'Text')) {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, selectedObject.gradient, selectedObject.Id);
      }
      this.emitUndoRedoRequest();
    },
    updateSelectedPointPosition(position) {
      const list = this.getSelectedObjectsList;
      if (this.isMultiPropertySelection) {
        list.forEach((object) => {
          this.updateSelectedPointPositionById(position, object.Id);
        });
      } else {
        const selectedObject = findFirstSelectedObject(this.contentList);
        if (!selectedObject) { return; }
        this.updateSelectedPointPositionById(position, selectedObject.Id);
      }
    },
    updateSelectedPointPositionById(position, objectId) {
      const selectedObject = findObjectById(this.contentList, objectId);
      const colors         = selectedObject && selectedObject.gradient && selectedObject.gradient.colors;
      if (!colors || !colors.length) { return; }

      const selectedColor    = colors.find(color => color.isSelected) || colors[0];
      this.$set(selectedColor, 'position', position);
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      this.applySvgGradientFill(selectedObject);
      this.emitUndoRedoRequest('from updateSelectedPointPositionById ');
    },
    updateSelectedPointOfGradient(index) {
      if (this.selectedObjectsList.length > 0) {
        this.getSelectedObjectsList.forEach((object) => {
          this.updateSelectedPointOfGradientById(index, object.Id);
        });
      }
    },
    updateSelectedPointOfGradientById(index, objectId) {
      const selectedObject = findObjectById(this.contentList, objectId);
      const colors         = selectedObject && selectedObject.gradient && selectedObject.gradient.colors;
      if (!colors || !colors.length) { return; }
      colors.forEach((point, i) => {
        this.$set(point, 'isSelected', i === index);
      });
    },
    ensureGradientDefaults(object) {
      if (!object) { return; }
      if (object.isGradient === undefined) {
        this.$set(object, 'isGradient', false);
      }
      if (!object.gradient || !object.gradient.colors || object.gradient.colors.length < 2) {
        this.$set(object, 'gradient', {
          angle:  0,
          colors: [
            {
              id:         '1',
              position:   0,
              color:      'red',
              isSelected: true,
              rgba:       'rgba(255,0,0,1)',
            },
            {
              id:         '2',
              position:   94,
              color:      'yellow',
              isSelected: false,
              rgba:       'rgba(234,239,44,1)',
            },
          ],
        });
      }
    },
    handleModeChange(isGradient) {
      console.log('is Gradient on mode change is ', isGradient);
      const selectedObjects = this.getSelectedObjectsList;
      if (selectedObjects.length > 0) {
        selectedObjects.forEach((object) => {
          this.handleModeChangeById(isGradient, object.Id);
        });
      } else if (this.activeObjectForLeftPanel) {
        this.handleModeChangeById(isGradient, this.activeObjectForLeftPanel.Id);
      }

      if (this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.ImageType && (this.activeObjectForLeftPanel.ImageType.indexOf('FDICText') !== -1 || this.activeObjectForLeftPanel.ImageType.indexOf('FDICLogo') !== -1)) {

      }
    },
    handleModeChangeById(isGradient, objectId) {
      const selectedObject = findObjectById(this.contentList, objectId);
      if (!selectedObject) { return; }
      this.ensureGradientDefaults(selectedObject);
      this.$set(selectedObject, 'isGradient', isGradient);
      EventBus.$emit(ApplicationEventTypes.LayerPanelEvents.UPDATE_DATA_ON_LAYER_SWAP, this.contentList);
      if (selectedObject.isGradient && isSvgStrokeObject(selectedObject)) {
        this.applySvgGradientFill(selectedObject);
      } else {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SVG_FILL_COLOR, selectedObject.SvgProperty ? selectedObject.SvgProperty.DefaultColor : 'rgba(255,255,255,0)', selectedObject.Id);
      }
    },
  },
};
